/* eslint-disable @typescript-eslint/no-misused-promises */

import { Modal, ModalProps, Button, Bubble, message } from '@tencent/tea-component';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import SharePoster, { PosterRef } from './SharePoster';
import './SharePosterModal.scss';
import QRCode from 'qrcode.react';
import { useEventID } from '@hooks/useEventId';
import { useActivityInfoToC } from 'src/hooks/useActivityInfo';
import beaconReport from '@utils/beacon';
import PosterList from './poster/PosterList';
import PosterConfigList from './poster/PosterList/PosterConfigList';
import { setLastPoster, getLastPoster } from '@model/poster';
import { DashboardEventInfoRes } from '@quickService/DashboardEventInfo';
import qrcodeLogo from '../imgs/logo.svg';

const PosterShareModal: React.FC<
  ModalProps & { event?: DashboardEventInfoRes['data']; onBack?(): void }
> = (props) => {
  const { visible, onClose, caption = '下载海报分享活动', event, onBack } = props;
  const { eventId: pathEventId } = useEventID();
  const eventId = event?.event_id || pathEventId;
  const { activityInfo } = useActivityInfoToC({ event_id: eventId });
  const shareLink = `${window.location.origin}/events/host/share-poster?eventid=${eventId}&fromPage=poster-code`;
  const posterRef = useRef<PosterRef>(null);
  const downloadPoster = useCallback(async () => {
    if (posterRef.current) {
      await posterRef.current.downloadPoster('海报');
    }
    beaconReport('e#event_poster_popup#download_poster#download');
  }, [posterRef]);

  useEffect(() => {
    if (visible) {
      beaconReport('e#event_poster_popup#all#exposure');
    }
  }, [visible]);
  const [selectedPosterIndex, setSelectedPosterIndex] = useState(0);

  useEffect(() => {
    if (visible) {
      getLastPoster({ event_id: eventId })
        .then(({ poster_id: postId }) => {
          setSelectedPosterIndex(postId);
        })
        .catch((msg) => message.error(msg));
    }
  }, [visible, eventId]);
  return (
    <Modal
      onClose={onClose}
      visible={visible}
      size={645}
      className="share-poster-modal"
      caption={
        <div className="dialog-title">
          {onBack ? <i className="iconfont icon-arrow-left" onClick={onBack} /> : null}
          <span className="dialog-title-txt">{caption}</span>
        </div>
      }
    >
      <Modal.Body>
        <div className="share-poster-modal-body">
          <div className="share-poster-content">
            <div className="poster-box">
              <div className="poster-box-container">
                <SharePoster
                  activityInfo={activityInfo}
                  ref={posterRef}
                  className="share-poster"
                  posterConfig={PosterConfigList[selectedPosterIndex]}
                />
              </div>
            </div>
            <PosterList
              selectedPoster={selectedPosterIndex}
              onSelect={(posterId) => {
                setSelectedPosterIndex(posterId);
                setLastPoster({ event_id: eventId, poster_id: `${posterId}` });
              }}
              posters={PosterConfigList}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="share-poster-modal-footer">
          <Button
            type="weak"
            className="download-btn"
            onClick={() => {
              Promise.resolve(downloadPoster());
            }}
          >
            下载到电脑
          </Button>
          <Bubble
            className="share-bubble"
            content={
              <div className="qrcode-contain">
                <div className="qrcode-contain-tip">扫描下方二维码下载海报至手机</div>
                <QRCode
                  value={shareLink}
                  size={168}
                  imageSettings={{
                    src: qrcodeLogo,
                    width: 32,
                    height: 32,
                    excavate: false,
                  }}
                />
              </div>
            }
            arrowPointAtCenter={true}
          >
            <Button type="primary">用手机分享</Button>
          </Bubble>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default PosterShareModal;
